export const loreCharacters = [
  {
    name: 'Captain Quacken',
    title: 'Founder and harbor captain',
    description: 'A one-legged duck with a sharp eye, a sharper tongue, and a hat three sizes too big for his feathery head.',
  },
  {
    name: 'Mistress Dystopia',
    title: 'Soothsayer and navigator',
    description: 'She steers fate with ancient star charts, cryptic whispers on the wind, and perhaps a bit too much rum.',
  },
  {
    name: 'Beth',
    title: 'Warrior and storyteller',
    description: 'Protector of the crew, teller of mountain-clan tales, and secret knitter of scarves no one dares to tease her about.',
  },
  {
    name: 'Prince Bubbles',
    title: 'Fae royalty and mischief maker',
    description: 'A prankster, poet, and maker of laughter whose shimmering wings and glowing trails light the crew’s way.',
  },
]

export const loreChapters = [
  {
    title: 'The voyage of The Wobblewink',
    paragraphs: [
      'As legend lovingly tells it, the Kingdom of Ourrenland was founded by a bold collection of misfits, dreamers, and delightfully ungovernable souls. Captain Quacken and Mistress Dystopia formed the heart of the ship’s leadership, with Beth and Prince Bubbles supplying equal measures of protection, mischief, storytelling, and spirit.',
      'They boarded The Wobblewink and sailed away from the over-regulated snooze-fest formerly known as Atlantis. They wanted a life filled with joy, weirdness, and freedom, far from dusty rules that made even sneezing without permission a finable offense.',
    ],
  },
  {
    title: 'The storm and the golden shore',
    paragraphs: [
      'One thunderous night, a storm turned the voyage into a giant, soggy rollercoaster. A mysterious fog followed. For three days and nights the crew drifted while even Dystopia’s crystal ball gave them nothing but static.',
      'When the fog lifted, The Wobblewink raced toward land under a will of its own. Captain Quacken tried every trick in the book, but the ship beached itself with dramatic flair. By miracle, luck, or Fae magic, everyone stepped safely onto a golden shore where crystal water, sparkling white sand, and emerald mountains seemed to hum with ancient magic.',
      'They had arrived at Mythralore Isle.',
    ],
  },
  {
    title: 'The laws of Mythralore',
    paragraphs: [
      'The island was uninhabited, untouched, and unbelievably beautiful. After joyful frolicking, several awkward cartwheels, and a very serious coconut-throwing competition, the travelers chose it as home.',
    ],
    laws: [
      'Enjoy the short life you have.',
      'Respect everyone’s way of life.',
      'Every kind heart is welcome.',
      'Work together to keep the island and one another strong.',
    ],
  },
  {
    title: 'The island that remembers',
    paragraphs: [
      'Mythralore is said to be alive, ancient, and aware. The wind carries the voices of long-gone guardians, and the forest glows faintly on certain nights, especially when new travelers arrive. Witches, warlocks, and faeries protect it in secret. Those who arrive intending harm are swallowed by the same fog that guided the founders home.',
      'Today, Mythralore is an offbeat seaport village where humans and magical creatures laugh, trade, sing, and occasionally swordfight over pastry recipes. Families have formed in wonderfully unexpected combinations. Bubbles hosts enchanted tea parties in treehouses, Beth teaches combat classes, and Captain Quacken still commands the harbor from a driftwood raft while Dystopia navigates by moonlight and mutters about stars with attitude.',
      'The legend lives on in every laugh, every new friend, and every star that lights the path home.',
    ],
  },
]

export const eventWaiver = {
  version: '2015-original-v1',
  title: 'Kingdom of Our Renland Event Waiver',
  paragraphs: [
    'This agreement releases Kingdom of Our Renland from all liability relating to injuries that may occur at guild events. By signing this agreement, I agree to hold Kingdom of OurRenland entirely free from any liability, including financial responsibility for injuries incurred, regardless of whether injuries are caused by negligence.',
    'I swear that I am participating voluntarily, and that all risks have been made clear to me. Additionally, I do not have any conditions that will increase my likelihood of experiencing injuries while engaging in this activity.',
    'By signing below I forfeit all right to bring a suit against Kingdom of Our Renland for any reason. I will also make every effort to obey safety precautions as listed in writing and as explained to me verbally. I will ask for clarification when needed.',
  ],
}
